<mat-accordion>
  <mat-expansion-panel 
    hideToggle
    (opened)="onToggle.emit(true)"
    (closed)="onToggle.emit(false)"
  >
    <mat-expansion-panel-header>
      <div class="dd-header-wrap">
        <span class="p2">{{title}}</span>
        <img 
          src="{{ 'arr-right' | iconByName }}"
          class="dd-icon"
          [ngClass]="{ 'dd-icon_rotate': isExpanded }"
        />
      </div>
    </mat-expansion-panel-header>

    <ng-content></ng-content>
  </mat-expansion-panel>
</mat-accordion>